import PropTypes from 'prop-types';

export const DefaultSourceDisplay = ({ source }) => {
  if (!source) return null;

  if (source.link) {
    return (
      <div className="flex text-xs text-gray-400 underline mr-2">
        <a href={source.link} target="_blank" rel="noreferrer">
          {source.name}
        </a>
      </div>
    );
  }

  return <div className="flex text-xs text-gray-400 mr-2">{source.name}</div>;
};

DefaultSourceDisplay.propTypes = {
  source: PropTypes.shape({
    name: PropTypes.string.isRequired,
    link: PropTypes.string,
  }),
};
